import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  DisplayPreArrivalFormField,
  PreArrivalFormFields,
} from '../PreArrivalFormTab.types';

const useShouldShowField = () => {
  const { watch } = useFormContext();

  const isFieldActive = useCallback(
    (fieldName: PreArrivalFormFields) => {
      const fieldValue = watch(fieldName) as DisplayPreArrivalFormField;
      return fieldValue.isActive;
    },
    [watch],
  );

  const shouldShowField = useCallback(
    (fieldName: PreArrivalFormFields, render: React.ReactElement) => {
      const fieldValue = watch(fieldName) as DisplayPreArrivalFormField;

      if (fieldValue) {
        const required = fieldValue.validation === 'REQUIRED';
        const shouldShow = fieldValue.isActive;

        if (shouldShow) {
          // inject required prop to the render
          return React.cloneElement(render, {
            required: required as boolean,
          });
        }
      }

      return null;
    },
    [watch],
  );

  return { shouldShowField, isFieldActive };
};

export default useShouldShowField;
